export default {
    fileSizeOfTool (limit = 0, fixed = 2, unitLimit = '') { // 传参limit为初始值, fixed为小数点省略
        let unit = unitLimit.toUpperCase() || '' // 单位
        let size = '' // 未处理小数点
        let meta = Number(limit)
        if (unit) {
            switch (unit) {
                case 'B': size = meta; break
                case 'KB': size = (meta / 1024); break
                case 'MB': size = (meta / (1024 * 1024)); break
                case 'GB': size = (meta / (1024 * 1024 * 1024)); break
                default: size = (meta / (1024 * 1024 * 1024)); break
            }
        } else {
            if (meta < 0.1 * 1024) { // 如果小于0.1KB转化成B
                unit = 'B'
                size = meta
            } else if (meta < 0.1 * 1024 * 1024) { // 如果小于0.1MB转化成KB
                unit = 'KB'
                size = (meta / 1024)
            } else if (meta < 0.1 * 1024 * 1024 * 1024) { // 如果小于0.1GB转化成MB
                unit = 'MB'
                size = (meta / (1024 * 1024))
            } else { // 其他转化成GB
                unit = 'GB'
                size = (meta / (1024 * 1024 * 1024))
            }
        }
        const text = size.toFixed(fixed).replace(`.${'0'.repeat(fixed)}`, '') // 当小数点后为0时 去掉小数部分
        return { text, meta, size, unit, fixed, format: text + unit }
        // fixed: 2 小数点后位数
        // format: "0.21MB" 单位格式化数据
        // meta: 224893 原始数据
        // size: 0.21447467803955078 未省略完整数据
        // text: "0.21" 省略文本数据
        // unit: "MB" 单位
    },
    getFileInfoByUrl (url) {
        const index = url.lastIndexOf('/')  // '/'所在的最后位置
        const filePath = url.substr(index + 1) // 处理文件服务拼接的bucketName问题
        const fileName = filePath.split('&')[0]  // 截取文件名称和后缀  输出：file.png
        const name = fileName.substring(0, fileName.lastIndexOf("."))  // 截取文件名   输出：file
        const fileSuffix = fileName.substring(fileName.lastIndexOf("."))  // 截取后缀   输出：.png
        const suffix = fileName.substring(fileName.lastIndexOf(".")+1)  // 截取后缀名  输出：png
        return { fileName, fileSuffix, name, suffix }
    },
    // 下载文件(txt文件不兼容，会出现乱码)
    fileDownloadByUrl (url, name) {
        const link = document.createElement('a');
        link.href = url;
        const array = url.split('.')
        const fileSuffix = array[array.length - 1] || ''
        const browserSupport = ['mp3', 'mp4', 'pdf'] // 浏览器支持打开的文件
        if (browserSupport.includes(fileSuffix.toLowerCase())) link.target = "_blank"
        link.style.display = 'none'
        link.href = url
        if (name) link.setAttribute('download', name)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link) // 下载完成移除元素
    }
}
